import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails39 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdevpir14.jpeg";
  return (
    <>
      {/* <div className="body_wrap">
        <div className="page_wrap"> */}
 <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      

      <Header />
      <div
        data-elementor-type="cpt_layouts"
        data-elementor-id="46"
        className="elementor elementor-46"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="52ebb12"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ height: "30rem", marginBottom: "5rem" }}
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
              data-id="ae9d67e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="fcf91b3"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                      data-id="93dfaf4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                          data-id="847c2c5"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                          style={{ height: "8rem" }}
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                          data-id="8fe49e3"
                          data-element_type="widget"
                          data-widget_type="trx_sc_layouts_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              id="trx_sc_layouts_title_515615674"
                              className="sc_layouts_title sc_align_center with_content without_image without_tint"
                            >
                              <div className="sc_layouts_title_content">
                                <div className="sc_layouts_title_title">
                                  {" "}
                                 
                                </div>
                                <div className="sc_layouts_title_breadcrumbs">
                                  <div className="breadcrumbs">
                                   
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



      <div className="page_content_wrap blog-details">
        <div className="content_wrap" >
          <div className="content">
            <div id="container" className="give-wrap container">
              <div id="content" role="main">
                <div
                  id="give-form-288-content"
                  className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                >
                  <div
                    id="give-sidebar-left"
                    className="give-sidebar give-single-form-sidebar-left"
                  >
                    <div className="images">
                      <img
                        width="1024"
                        height="576"
                        src={img1}
                        className="attachment-large size-large wp-post-image blog-img"
                        alt=""
                        decoding="async"
                        sizes="(max-width: 1024px) 100vw, 1024px"
                      />
                    </div>
                  </div>
                  <div className="summary entry-summary">
                    <h2 itemProp="name" className="give-form-title entry-title">
                      ભક્ત દાહા ખાચરને જીવતદાન

                    </h2>{" "}
                    <div
                      id="give-form-288-wrap"
                      className="give-form-wrap give-display-onpage"
                    >
                      <div className="give-goal-progress">
                        <div
                          className="raised blog-title"
                                                  >
                          <span className="income">ભક્ત દાહા ખાચરને જીવતદાન


                          </span>
                        </div>
                      </div>

                      <div
                        id="give-form-content-288"
                        className="give-form-content-wrap give_pre_form-content"
                      >
                        <p className="paragraph-content" >
                          ચોપાઈ
                          કાઠી ભકત નસીદપુર ગામે, ‘આપા દાહા ખાચર' નામે, ફક્કડાનાથનો શિષ્ય કહાવે, રામદે'પીરની ધૂન લગાવે.
                          નસીદપુર નામના ગામમાં ખાચર, ખુમાણા, ખવડવાળા, જળું એવી શાખાના કાઠી રાજપૂતો, બ્રાહ્મણ, વાણિયા, કણબી વગેરે રહેતા હતા. ગામ સંપીલું અને સુખસંપત્તિવાળું ગણાતું હતું. ત્યાંના આપા દાહા ખાચર, ઉપર ફક્કડાનાથની કૃપા થઈ અને તેમને શિષ્ય કર્યા. આપા દાહા રામદેવજીના આસ્તિક અને નિત્ય
                          નિયમવાળા હતા. એમને બધા દાહા ભગત કહેતા.
                          નસીદપુરમાં બીજો એક માથા ભારે તળપદો કોળી રહેતો. એનું નામ નાજો પગી. શિહોર દરબાર તરફથી એને પગીપણું મળ્યું હતું. તેના સાગ્રીતો પણ કરાફાતિયા હતા.
                          કોઈનાં ઢોરને સંતાડી પછી ગોતી આપવાં મહેનતાણું લેવું. આવા ખાપધાપના ધંધા કરવામાં નાજો પગી પાવરધો હતો.
                          પગીને જરૂરી કામ માટે બહાર જવાનું હતું તેથી તે દાહા ભગતની ઘોડી લેવા આવ્યો. ભગતનાં પત્ની કાઠિયાણી આઈ ધનબાઈએ ઘોડી આપવાની ના કહી. પોતાના મોભામર્યાદાને છાજે એવા શબ્દોથી જણાવ્યું કે કાઠીની ઘોડી પર કોળી રંગ વાળી શકે નહીં.
                          આઈ ધનબાઈના શબ્દોથી નાજો તરત પાછો વળ્યો પણ આપા દાહાનો પાકો વિરોધી બન્યો. તેમની નિન્દા, કુથલી કરવા લાગ્યો. ગામ વચ્ચે ચોરામાં એક ઠાકોર મંદિરનો ઓરડો હતો. ત્યાં સવારસાંજ કાઠી દરબારનો ડાયરો ભરાય. એ ડાયરામાં નાજો પગી અને તેના સાગ્રીતો આવવા લાગ્યા. તેઓ આપા દાહાની નિન્દા, કુથલી ખણખોદ કરે અને આપા દાહાની વિરુદ્ધ વાતો કરીને ડાયરાને પોતાના વલણ તરફ
                          વાળવા લાગ્યા.
                          એક સાંજે જમી પરવારી ઠાકોરજીની આરતી લઈ બધા ડાયરામાં બેઠા હતા. એવામાં નાજાએ પોતાનું પોત પ્રકાશ્યું ! તેણે દાહા ભગતને કહ્યું : ‘બાપુ ! તમે

                        </p>
                        <p className="paragraph-content">
                          રોજ ઝમરાળામાં ફક્કડા બાવા પાસે જાવ છો. ત્યાંથી તમે જે જ્ઞાન મેળવ્યું હોય, એમાંથી થોડુંક જ્ઞાન ડાયરામાં તો વહેંચો ?' નાજો કર્કશ ભાષામાં બોલ્યો.
                          “ખરૂં છે પગી ! ગુરુશાન બધાંયને સંભળાવો આપા !' ડાયરામાં બેઠેલા બીજાએ ટાપશી પૂરી, પગીની વાતનો દાહા ભગતે ઉત્તર આપ્યો નહીં અને સાંભળી રહ્યા. પગીએ વાત આગળ ચલાવી, અત્યારે નસીદપુર ગામ નસીબવાળું થયું છે. આપા દાષા જેવા ભગત અને ફક્કડિયા બાવા જેવા ગુરુ ગામના નસીબે મળી
                          ગયા !' પગીએ શબ્દપ્રહાર કરવા માંડ્યા.
                          ‘પગી ! તમેય ગુરુકંઠી બાંધો ભાઈ ! ગુરુ કરી લો !' ડાયરામાં વયોવૃદ્ધ આપા ખાચરે કહ્યું. નાજો બોલ્યો : ‘હું કંઠી બાંધું ? ગુરુની પરીક્ષા લીધા વિના હું ગુરુ કરું ? આપા અત્યારના ગુરુ કેવા હોય છે એ સાંભળો.' પગી બોલ્યો :
                          દોહા
                          ગુરુ થવું સહુને ગમે, ચેલાથી લે કામ, દાન, દાપુ ને દક્ષિણા, લઈ કરતા આરામ. ચોપાઈ
                          ધરે ગળામાં લક્કડમાળ, ધતિંગિયા, ઢોંગી દંભાળા, અતિ વિલાસી, શ્રમ ભેદાળા, પાખંડી ભક્તિના ચાળા. ચેલા, બાલક, જુવાન, ઘરડાં, ગુરુ ગણે ઘેટાં ગાડરડાં, કે'તા ધનનો મોહ ન કરજો, તન મન ધન સૌ અમને ઘરજો.
                          દોહા
                          ગુરુ થવું સહુને ગમે, ચેલા બને ન કોઈ,
                          જો ગુરુ ચેલા બને, સેવા લાયક સોઈ.
                          ‘આપા દાઠા ભગત છે. એમણે ઝમરાળાની નદીમાં બેઠેલા ફક્કડાબાવા જે
                          હનુમાન કહેવાય છે, એમને ગુરુ કર્યા છે.’
                          ‘ભગત બાપુને ખરી વાતોમાં ખાર ના હોય. નુગરા, સુગરા એ નામ તો ગુરુ થનારાઓએ ગોઠવ્યાં છે. આપા દાહા જેવા ભલાભોળા માણસોને આ બધું સમજાવવા માટે છે.
                          ચોપાઈ
                          તગડા ! ફક્કડાને ગુરુ માના, વગર પૂછડાના હનુમાન ! જમાવતા ચેલાનાં ટોળાં, આપા દાહા જેવા ભોળા.

                        </p>
                        <p className="paragraph-content">
                          ‘દાહા બાપુના ગુરુ ફક્કડા હનુમાન છે પણ વગર પૂંછડાના છે ! એમણે દેવનું પગેરું ગોતી કાઢી આપા દાણાને બતાવ્યું છે.
                          ચોપાઈ.
                          દાહા દેવ તણા અવતારા, ઉતારશે સહુને ભવપારા,
                          કરે મશ્કરી કોળી નાજો, કલવારા પણ મુકતા માઝો.
                          કોળી નાજો પગી એના સાથીદાર ચાર કલવારા પણ હદ ઓળંગી મશ્કરી- ઠઠ્ઠાઠેકડી કરવા લાગ્યા. ડાયરામાં ઘણાના દિલમાં દાહા ભગત પ્રત્યે ભલી લાગણી થઈ અને પગીને મીઠો ઠપકો આપ્યો : “પગી ! તારી મશ્કરી- ઠઠ્ઠાની ટેવ છોડી દે ભાઈ ! ડાયરામાં બધાં મૂર્ખા નથી.' અદાએ જણાવ્યું.
                          દાહા ભગતની સહનશક્તિ અગાધ હતી. ડાયરાની ચર્ચાથી તેમનું મન ડોલાયમાન થતું ન હતું. વ્યર્થ વાદવિવાદમાં ઊતરવું નહીં અને મૌન સેવવું, એવો ગુરૂઆદેશ દાહા ભગતે જીવનમાં વણી લીધો હતો.
                          ‘ભગત બાપુ ! કાંઈક તો પગીને જવાબ આપો ! મૂંગા કેમ બેસી રહ્યા છો ?' એક જણે કહ્યું .
                          પગીની વાતો સાંભળી તેઓ બોલ્યા : ‘નાજો, ડાયરાને વાતો સંભળાવી આનંદથી ધરવી દે છે અને હું યે ધરાઉં છું. હજી ઘણી વાતો મારે પગી પાસેથી સાંભળવી છે. પીરાઈની નિન્દા કરવાથી નુગરાને પાપ નથી લાગતું ભાઈ !' દાહી ભગતે મર્મમાં સંભળાવ્યું. બધા દાહા ભગતની વાત સાંભળી વિચારમાં પડી ગયા.
                          ‘રોજના નિયમ પ્રમાણે રાતે ચોકડિયા ભજનધૂનથી પરવારી તેઓ ગાયની ગમાણ પાસે ગયા. ડેલીમાં એક ભયાનક બનાવ બન્યો. ખાળમાંથી સાપ આવી ભગતના પગે દંશ દઈ દોડી ગયો.
                          સર્પડંશથી ભગતે ‘હે રામદેવજી !'નો પોકાર પાડતાં આઈ ધનબાઈ દોડતાં આવ્યાં. પાડોશમાંથી અને ગામમાંથી માણસો દોડી આવ્યાં. લીમડાના પાન ચવરાવવાનો ઉપચાર કરવા માંડ્યો પણ ભગતે ના કહી અને ગુરુનાં દર્શન કરવાં સવારે ઝમરાળા નહીં જવાય એમ ધારીને ‘જય ગુરુદેવ ! જય ફક્કડાનાથ ! જય હનુમાન’ની ધૂન કરતાં જીભના લોચા વાળવા લાગ્યા. ભગતના ગુરુને ઝટ તેડાવો એવી લોકોની સલાહથી સાંઢણીસ્વાર ઝમરાળા ગયો. અને સવાર પડતાં ફક્કડાનાથને તેડી આવ્યા. ફક્કડાનાથે આવીને જોયું તો ભગતે ઝેર વ્યાપી જવાથી દેહ છોડી દીધો હતો !

                        </p>
                        <p className="paragraph-content">
                          ફક્કડાનાથનાં દર્શન ભગતને થયાં નહી. ભગતની આશા અધૂરી રહી. અજાનબાહુ ફક્કડાનાથને જોતાં લોકો શાંતિથી ઊભાં રહ્યાં, દોહા ભગતને સ્મશાન લઈ જવા શબને ચાદરથી ઢાંક્યું હતું. આઈ ધનબાઈ આંસુ સારતાં હતાં. તેઓ બાપુ ! બાપુ ! કહેતાં ગુરુના ચરણોમાં ઢળી પડ્યાં,
                          ચોપાઈ
                          આપાને એરૂ થયો વેરી, આખું અંગ થઈ ગયું ઝેરી,
                          સુણો ગુરુ પક્કડા હનુમાના, ચેલાને દૌ જીવતદાના
                          આ બનાવ જોઈને ફક્કડાનાથ ગંભીર વિચારમાં પડી ગયા હતા, ફક્કડાનાથે ‘અલખ ! નકળંગ !' ‘જય રામદેવજી ! અંગ ભંગ કર દો અભંગ'નો ઉચ્ચાર કરી શબને ઢાંકેલી ચાદર ખેંચી ધૃતજ્યોત પ્રગટાવી. ભગતના માથા અને મોઢા પર હાથ ફેરવી અલખ ઝોળીમાંથી ભસ્મની ચપટી ભરી મુખમાં મૂકી, કમંડળમાંથી અંજિલ ભરી મોઢામાં રેડી. ગળામાંથી માળા કાઢી ભગતને અંગુઠાથી ચોટલી સુધી માળાનો સ્પર્શ કરાવ્યો અને પુનર્જીવન આપવા રામદેવજી અને રામગરજીનું ધ્યાન ધરી
                          બોલ્યા :
                          ‘ઊઠો ! જાગૃત થાવ ! ભગત ! જ્યોતિ દર્શન કરો.' ગરલને અમૃતરસનો પાસ લાગે અને જીવન મળે ! એમ ભગતનો શ્વાસોશ્વાસ ચાલતો થયો. ભગતે આંખો ઉઘાડી સામે રાખેલી ધીની જ્યોતનાં દર્શન કરી ‘જય ગુરૂદેવ’નો ઉચ્ચાર કરી બેઠા થઈ ફક્કડાનાથના ચરણે માથું નમાવ્યું.
                          એકઠાં થયેલા માણસો આ પ્રસંગ જોઈ હેરત પામી ગયા અને ‘જય ફક્કડાનાથ, જય હનુમાન, જય રામાપીર, જય દાહા ભગત !' ના જયનાદથી દિશાઓ ગજાવી મૂકી. પગી અને સાથીદારો આ પીરાઈ પરચો જોઈ દિગ્મૂઢ બની ગયા ! ફક્કડાનાથને શીશ ઝુકાવવાથી ફક્કડાનાથ એમના માનસને પારખીને બોલ્યા : ‘પગી ! દાહા ભગતની નિન્દા- ખોદણી કરીને એમનાં પાપ ધોવા તમે પાંચે જણાએ જે મહેનત લીધી હતી, એ પાપ તમે ધોઈ નાખવાથી ભગતને ફરી જીવન મળ્યું છે. હવે તેં વગર પૂંછડાના હનુમાન માટે તેલ ચડાવવાનો જે સંકલ્પ કર્યો છે, તે સંભળાવ ! સત્ય છુપાવીશ તો હનુમાનની બાધા પૂરી નહીં થાય.
                          ચોપાઈ
                          બાધા રાખી છે. અમે, મનમાં રાખી ટેક,
                          તેલ લઈ હનુમાનને, કરાવવો અભિષેક.

                        </p>
                        <p className="paragraph-content">
                          નાજો પગી ફક્કડાનાથ પાસે ગભરાતા હ્રદયે બોલ્યો, ‘તો જલદી ઊભો થ અને તેલનું કુંડલું ભરેલું છે. તે લાવ અને મારે માથે તેલ ચડાવી તારી બાધા પૂરી કર.' ફકકડાનાથે ઊંચા અવાજે કહ્યું. પગી ધ્રૂજવા લાગ્યો અને ભેગું કરેલું સવામણ તેલનું ભરેલું કુંડલું પગી અને તેના સાથીદારો લઈ આવ્યા. ગામની વસતી રૂબરૂ તેલ ચડાવવાનું કાઠી દરબારોએ પગીને જણાવ્યું,
                          ફક્કડાનાથના માથે તેલ રેડવા માંડ્યું. સૌના આશ્ચર્ય વચ્ચે એ તેલ એમના વાળમાં સમાઈ ગયું. આ અદ્ભુત ચમત્કાર જોઈ ગામના લોકોએ જય હનુમાનની ઘોષણા ગજાવી મૂકી.
                          ફક્કડાનાથે માથા પર હાથ ફેરવી તેલના છાંટા પ્રજાને છાંટી વચન આપ્યું કે જ્યાં સુધી દાહો ભગત અને આઈ ધનબાઈ જીવતાં હશે, ત્યાં સુધી આ નસીદપુરમાં નાનાં મોટાં દીકરી- દીકરા મા-બાપ પહેલાં નહીં મરે, ઘેર ઘેર રામદેવજી મહારાજનું સ્મરણ કરજો, ‘જય રામાપીર.' એ વખતે ગામની સ્ત્રીઓ પોતાનાં બાળકોને લાવી એમને પગે લગાડવા લાગી. ફક્કડાનાથ ત્યાંથી તરત વિદાય થયા અને પોતાના આસને આવ્યા.
                          એ જ રાતે નાજો પગી અને ચાર કલવારા ખાટલામાં સૂતેલા હતા. ત્યાં તેઓ અંગભંગ થઈ ગયા અને પાંગળા બની ગયા ! તેઓ બૂમાબૂમ કરવા લાગ્યા. ગામલોકોએ તેમની આ દશાને પાપના ફળ તરીકે ગણાવી. છેવટે બધાના કહેવાથી ફક્કડાનાથને તેડાવ્યા પણ તેમણે જણાવ્યું કે ‘નુગરાનો નેડો નહીં અને જળમાં કેડો નહીં.'
                          પાપનું ફળ એને ભોગવવું જ પડશે. સાધુ, સંત, ગુરુ અને ભક્તની નિંદા ક૨ના૨ને ભગવાન રામદેવજી સલામત રહેવા દેતા નથી. જય રામદેવજી !
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
      {/* </div>
      </div> */}
      <div>
        <Footer />
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
      </div>
    </>
  );
};

export default BlogDetails39;
